import { Anchor, Box, Flex, Loader, Modal } from '@mantine/core';
import { IconBook } from '@tabler/icons-react';
import { useCallback, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router';
import ErrorMessage from '../../components/ErrorMessage';
import GenerateNewContentButton from '../../components/GeneratedContent/GenerateNewContentButton';
import GeneratedContentSideBar from '../../components/GeneratedContent/GeneratedContentSideBar';
import Metadata from '../../components/Metadata';
import PromptGuideModal from '../../components/Modals/PromptGuideModal';
import GeneratedContentDetails from '../../constants/GeneratedContentDetails';
import { Page } from '../../constants/pageTitles';
import useFetch from '../../helpers/useFetch';
import GeneratedContentLandingForm from './GeneratedContentLandingForm';

const GeneratedContentDetailsPage = () => {
  const fetch = useFetch();
  const navigate = useNavigate();

  const { accountId, domainId, generatedContentId } = useParams();
  const [error, setError] = useState();
  const [newModalOpen, setNewModalOpen] = useState(false);
  const [promptGuideModalOpen, setPromptGuideModalOpen] = useState(false);

  const [generatedContents, setGeneratedContents] = useState();

  const fetchUrl = `/api/admin/accounts/${accountId}/domains/${domainId}/generatedContent`;

  const refreshContents = useCallback(() => {
    fetch(fetchUrl)
      .then(({ generatedContents }) => {
        if (generatedContents.length === 0) {
          navigate(`/accounts/${accountId}/domains/${domainId}/generatedLanding`);
          return;
        }

        setGeneratedContents(generatedContents.filter((content) => content.marketingChannel !== 'chatBot'));
      })
      .catch(setError);
  }, [accountId, domainId, fetch, fetchUrl, navigate]);

  useEffect(() => {
    refreshContents();
  }, [refreshContents]);

  useEffect(() => {
    const isMenuCollapsed = document.querySelector('.collapsed-menu');

    if (!isMenuCollapsed) {
      document.querySelector('[data-sidebar-toggle]')?.click();
    }
  }, []);

  if (generatedContents === undefined) {
    return <Loader />;
  }

  if (error) {
    return <ErrorMessage message={error.message} />;
  }

  const createButton = <GenerateNewContentButton title="Create" onClick={() => setNewModalOpen(true)} />;

  return (
    <div style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
      <Metadata title={`${Page['generatedContent']}`} />

      <Flex gap="md" style={{ flex: 1 }}>
        <Box style={{ width: 250, minWidth: 250, flexShrink: 0 }} p="md">
          <Flex justify="center" align="center">
            <Anchor
              component="button"
              type="button"
              onClick={() => {
                setPromptGuideModalOpen(!promptGuideModalOpen);
              }}
            >
              <IconBook size={18} style={{ verticalAlign: 'middle' }} />
              <span style={{ padding: 10 }}>Essentials Guide to AI Prompting</span>
            </Anchor>
          </Flex>
          <hr />
          <GeneratedContentSideBar
            generatedContents={generatedContents}
            refreshContents={refreshContents}
            createButton={createButton}
          />
        </Box>

        <Box style={{ flex: 1, minWidth: 0, display: 'flex', flexDirection: 'column' }}>
          <GeneratedContentDetails refreshContents={refreshContents} createButton={createButton} />
        </Box>
      </Flex>

      <Modal opened={newModalOpen} onClose={() => setNewModalOpen(false)} size="xl" title="New Content">
        <GeneratedContentLandingForm
          parentContent={generatedContents.find((c) => c.id.toString() === generatedContentId)}
          onSubmit={({ id }) => {
            navigate(`/accounts/${accountId}/domains/${domainId}/generatedContent/${id}`);
            setNewModalOpen(false);
          }}
        />
      </Modal>
      <PromptGuideModal promptGuideModalOpen={promptGuideModalOpen} setPromptGuideModalOpen={setPromptGuideModalOpen} />
    </div>
  );
};

export default GeneratedContentDetailsPage;
